import { AuthenticationController } from './views/authentication/authentication';
import { LoginRemoteController } from './views/type_remote/type_remote';
import { LoginFormController } from './views/type_form/type_form';
import { LogoutLinkComponent } from './components/logout_link/logout_link';

require('./vendor.ts');

angular
  .module('capability-ng-authentication', ['ui.router', 'data-ng-authentication'])
  .controller('AuthenticationController', AuthenticationController)
  .controller('loginRemoteController', LoginRemoteController)
  .controller('loginFormController', LoginFormController)
  .component('logoutLink', new LogoutLinkComponent() as any);

require('./core.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/main.ts